import { hexToHsl, normalizeHex } from './color';

export const hslToHex = (h: number, s: number, l: number): string => {
  const hue = ((h % 360) + 360) % 360;
  const saturation = Math.max(0, Math.min(1, s));
  const lightness = Math.max(0, Math.min(1, l));
  const chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  const segment = hue / 60;
  const x = chroma * (1 - Math.abs(segment % 2 - 1));
  const [r, g, b] = segment < 1 ? [chroma, x, 0] : segment < 2 ? [x, chroma, 0]
    : segment < 3 ? [0, chroma, x] : segment < 4 ? [0, x, chroma]
      : segment < 5 ? [x, 0, chroma] : [chroma, 0, x];
  const shift = lightness - chroma / 2;
  return `#${[r, g, b].map(value => Math.round((value + shift) * 255)
    .toString(16).padStart(2, '0')).join('')}`;
};

export type TPaletteKind = 'complementary' | 'analogous' | 'triadic';

export const harmonyPalette = (baseHex: string, kind: TPaletteKind): string[] => {
  const base = normalizeHex(baseHex);
  const hsl = base && hexToHsl(base);
  if (!base || !hsl) return [];
  const hue = (offset: number) => hslToHex(hsl.h + offset, hsl.s, hsl.l);
  const colors = kind === 'complementary' ? [base, hue(180)]
    : kind === 'analogous' ? [hue(-30), base, hue(30)]
      : [base, hue(120), hue(240)];
  return [...colors, '#1f2a37', '#ffffff'];
};

export const DEFAULT_SWATCHES: string[] = [
  '#1f2a37', '#ffffff', '#c2410c', '#0e7490', '#2d9cc9',
  '#f5b301', '#0e9f6e', '#d64545', '#7c3aed', '#fff6e8',
];
